<template>
    <v-container grid-list-md>
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form>
                <v-card>
                    <v-card-title primary-title>
                        <v-btn
                            icon
                            @click="
                                $inertia.visit(
                                    $route(
                                        'tenant.outlets.index',
                                        $page.props.tenant.id
                                    )
                                )
                            "
                            ><v-icon>mdi-arrow-left</v-icon></v-btn
                        >
                        {{ $t("Create Product") }}
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <ShopFormProduct
                            v-model="item"
                            :categories="categories"
                            :subcategories="subcategories"
                            :units="units"
                            :taxes="taxes"
                            :parents="parents"
                        ></ShopFormProduct>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click.native="submit()"
                            :loading="item.processing"
                            :disabled="invalid"
                        >
                            <v-icon left>mdi-content-save</v-icon>
                            {{ $t("Save") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </ValidationObserver>
    </v-container>
</template>
<script>
    import ShopFormProduct from "@Shop/forms/ShopFormProduct.vue";
    export default {
        components: {
            ShopFormProduct,
        },
        props: ["categories", "subcategories", "units", "taxes", "parents"],
        data() {
            return {
                item: this.$inertia.form({
                    name: {
                        en: null,
                        km: null,
                        fr: null,
                        zh: null,
                    },
                    sku: null,
                    unit_id: null,
                    category_id: null,
                    parent_id: null,
                    type: null,
                    price: 0,
                    variations: [],
                    extras: [],
                    image: {},
                    settings: {},
                    description: {
                        en: null,
                        km: null,
                        fr: null,
                        zh: null,
                    },
                    minimum_quantity: 1,
                    maximum_quantity: 100,
                    daily_limit_quantity: 1000,
                    proparation_duration: 5,
                }),
            };
        },
        methods: {
            submit() {
                this.item.post(
                    this.$route("tenant.products.store", this.$page.props.tenant.id)
                );
            },
        },
    };
</script>
